import odata from 'odata-client';
import {
  UPDATE_ORGANISATION_DATA_REQUEST,
  UPDATE_ORGANISATION_DATA_ERROR,
  UPDATE_ORGANISATION_DATA_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';

export const tokenExpired = () => ({
  type: TOKEN_EXPIRED
});

export const updateOrganisationDataRequest = () => ({
  type: UPDATE_ORGANISATION_DATA_REQUEST
});

export const updateOrganisationDataError = errorOrResults => ({
  type: UPDATE_ORGANISATION_DATA_ERROR,
  error: errorOrResults.message
});

export const updateOrganisationDataSuccess = payload => ({
  type: UPDATE_ORGANISATION_DATA_SUCCESS,
  payload
});

export default (organisationData, organisationDataTableData) => async (dispatch, getState) => {

  dispatch(updateOrganisationDataRequest());

  const query = odata({ service: getServiceUrl() }).resource(RESOURCES.OrganisationData, organisationData.ID);
  const errorOrResult = await query.patch({ ...organisationData }, {
    headers: {
      Authorization: `Bearer ${getState().user.token}`,
      ...getDefaultHeader()
    }
  })
    .then(resp => resp)
    .then(res => {
      const ok = res.statusCode <= 299 && res.statusCode >= 200;

      if (res.statusCode === 500) {
        const errorKey = "GENERAL_SERVER_ERROR";
        return new Error(errorKey);
      } else if (!ok) {
        const response = res.toJSON()
        const error = JSON.parse(response.body).Error
        const errorKey = res.statusCode === 401 ? `401: ${error.Details[0].Message}` : `${error.Details[0].Message}`;
        console.log("update organisationData api error", response);
        return new Error(errorKey);
      } else {
        const payload = organisationData;
        payload.tableData = organisationDataTableData;
        return payload;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      dispatch(showNotification("Request probably timed out.", "error"))
    });

  if (errorOrResult instanceof Error) {
    dispatch(updateOrganisationDataError(UPDATE_ORGANISATION_DATA_ERROR, errorOrResult.message));
    if (errorOrResult.message.split(":")[0] === "401") {
      dispatch(tokenExpired());
      dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
    }
    console.log("CODE ERROR: ", errorOrResult.message);
    dispatch(showNotification(errorOrResult.message.split(",")[1], "error"))
    return errorOrResult;
  } else {
    dispatch(showNotification("SUCCESSFUL_SAVE", "success"))
  }

  dispatch(updateOrganisationDataSuccess(errorOrResult));

  return errorOrResult;
};
